/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Period_TodayInputs */

const en_directory_vibebids_period_today = /** @type {(inputs: Directory_Vibebids_Period_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const zh_directory_vibebids_period_today = /** @type {(inputs: Directory_Vibebids_Period_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Directory_Vibebids_Period_TodayInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_period_today = /** @type {((inputs?: Directory_Vibebids_Period_TodayInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Period_TodayInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_period_today(inputs)
	return zh_directory_vibebids_period_today(inputs)
});
export { directory_vibebids_period_today as "directory.vibebids.period_today" }